import i18next from 'i18next';
import { ActivityStatus } from 'infrastructure/enums';

export interface IActivityStatusItem {
  id: ActivityStatus;
  name: string;
}

export const activityStatusesDataSource = (): IActivityStatusItem[] => {
  const dataSource: IActivityStatusItem[] = [
    {
      id: ActivityStatus.Actioned,
      name: i18next.t('activityStatuses.actioned'),
    },
    {
      id: ActivityStatus.Unactioned,
      name: i18next.t('activityStatuses.unactioned'),
    },
    {
      id: ActivityStatus.UnactionedNormalRisk,
      name: i18next.t('activityStatuses.unactioned'),
    },
    {
      id: ActivityStatus.UnactionedCritical,
      name: i18next.t('activityStatuses.unactioned'),
    },
    {
      id: ActivityStatus.Erroneous,
      name: i18next.t('activityStatuses.erroneous'),
    },
  ];

  return dataSource;
};
